import { WIZARD_DEFINITION as WIZARD_DEFINITION_TERMINAL,
} from 'src/productconfig/customer/fiege/terminal-wizard-definition.config';

import { WIZARD_DEFINITION as WIZARD_DEFINITION_ONLINE_TERMINAL,
} from 'src/productconfig/customer/fiege/onlineterminal-wizard-definition.config';

import {WIDGET_DEFINITION as YARD_WIDGET_DEFINITION,
  WIZARD_DEFINITION as YARD_WIZARD_DEFINITION,
  WIZARD_STEP_CONTROLLER as YARD_WIZARD_STEP_CONTROLLER,
  TmcYardProductModule
} from 'src/tmc-yard/tmc-yard.product';

import {WIDGET_DEFINITION as VISITORS_WIDGET_DEFINITION,
  WIZARD_DEFINITION as VISITORS_WIZARD_DEFINITION,
  WIZARD_STEP_CONTROLLER as VISITORS_WIZARD_STEP_CONTROLLER,
  TmcVisitModule} from 'src/tmc-visit/tmc-visit.product';

import {WIDGET_DEFINITION as TMC_COMMON_WIDGET_DEFINITION,
  WIZARD_DEFINITION as TMC_COMMON_WIZARD_DEFINITION,
  WIZARD_STEP_CONTROLLER as TMC_COMMON_WIZARD_STEP_CONTROLLER,
  TmcCommonModule} from 'src/tmc-common/tmc-common.product';

import { ErpArticleModule } from 'src/erp-articles/erp-article.module';
import { ErpProjectModule } from 'src/erp-projects/project/project.module';


export const MODULES = [
TmcYardProductModule,
TmcCommonModule, TmcVisitModule, ErpArticleModule, ErpProjectModule];

export const WIDGET_DEFINITION = [
...TMC_COMMON_WIDGET_DEFINITION,
...YARD_WIDGET_DEFINITION,
...VISITORS_WIDGET_DEFINITION];

export const WIZARD_STEP_CONTROLLER = [
...TMC_COMMON_WIZARD_STEP_CONTROLLER,
...VISITORS_WIZARD_STEP_CONTROLLER,
...YARD_WIZARD_STEP_CONTROLLER];

export const WIZARD_DEFINITION = [
...TMC_COMMON_WIZARD_DEFINITION,
...VISITORS_WIZARD_DEFINITION,
...YARD_WIZARD_DEFINITION,
WIZARD_DEFINITION_TERMINAL,
WIZARD_DEFINITION_ONLINE_TERMINAL];
